var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5c0 0-7 7.33-7 13.5 0 3.59 3.13 5.5 7 5.5s7-1.91 7-5.5C19 9.83 12 2.5 12 2.5zm0 17c-2.21 0-4-1.29-4-3.5 0-2.89 2.34-6.77 4-9.24 1.66 2.47 4 6.35 4 9.24 0 2.21-1.79 3.5-4 3.5zm-1-5.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S13.33 12.5 12.5 12.5 11 13.17 11 14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.5a7b6ac21d0715bc18cceacda528ece5.svg";
export { ForwardRef as ReactComponent };